import type { ClientError } from '@tribeplatform/gql-client/lib'
import type { CreateEmojiInput, Emoji } from '@tribeplatform/gql-client/types'

import {
  useMutation,
  UseMutationOptions,
} from '../../lib/react-query/useMutation.js'
import { useTribeClient } from '../../useTribeClient.js'

export const useCreateEmojis = (options?: {
  useMutationOptions?: UseMutationOptions<
    Emoji[],
    ClientError,
    Array<CreateEmojiInput>
  >
}) => {
  const { useMutationOptions } = options || {}
  const { client } = useTribeClient()

  return useMutation<Emoji[], ClientError, Array<CreateEmojiInput>>(
    (input: CreateEmojiInput[]) => client.media.createEmojis(input),
    {
      ...useMutationOptions,
    },
  )
}
